import type { AddTranslationAsyncTaskDTO } from '../service/ai-translation.repository.interface';
import type { TaskInfo } from '../type/ai-translation.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { AddTranslationAsyncTask } from '@/infrastructure/api-functions/interface/add-translation-async-task.interface';

@injectable()
export class AddTranslationAsyncTaskDTOImpl implements AddTranslationAsyncTaskDTO {
    constructor(
        @inject(AddTranslationAsyncTask)
        private readonly _addTranslationAsyncTask: AddTranslationAsyncTask,
    ) { }

    async fetch(value: TaskInfo): Promise<void> {
        const params = {
            task_id: value.taskId,
            current_step: value.currentStep,
        };
        return await this._addTranslationAsyncTask.addTranslationAsyncTask(params);
    }
}
